var showcase = document.querySelector('.showcase')
var showcaseSkipIntro = sessionStorage.getItem('stihl_gb_2020_intro_status') === 'watched'

if(showcase) {
  var showcasePlayer = document.querySelector('.showcase__player')
  var showcaseVideoURL = 'https://player.vimeo.com/video/535922029?background=1&amp;dnt=1'
  var showcaseMask = showcase.querySelector('.showcase__mask')
  var showcaseAllSteps = [...showcaseMask.querySelectorAll('svg > g')]
  let supportsClassListForSVGNodes = !!showcaseAllSteps[0].classList

  if(showcaseSkipIntro || !supportsClassListForSVGNodes) {
    showcaseLoadVideo()
  } else {
    var showcaseText = showcase.querySelector('.showcase__text')
    var showcaseStepCounter = showcaseAllSteps.length - 1
    var documentBody = document.querySelector('body')
    var showcaseAnimationDelay: number = 1000
    var showcaseStepDelay: number = 300
    var showcaseFinalTransitionDelay: number = 500
    var showcaseAnimation

    showcaseSetStage()
    showcaseLoadVideo()
    showcaseInitializeAnimation()
  }
}

function showcaseSetStage() {
  showcase.classList.add('showcase--fullscreen')
  showcaseText.classList.add('invisible')
  showcaseAllSteps.forEach(step => step.classList.add('hidden'))
  showcaseAllSteps[showcaseStepCounter].classList.remove('hidden')
}

function showcaseLoadVideo() {
  showcasePlayer.setAttribute('src', showcaseVideoURL)
}

function showcaseStartAnimation() {
  showcaseAnimation = window.setInterval(function(){
    if(showcaseStepCounter == 1) {
      showcaseFadeout()
    }
    showcaseAllSteps[showcaseStepCounter].classList.add('invisible')
    showcaseStepCounter--
    if(showcaseStepCounter >= 0) showcaseAllSteps[showcaseStepCounter].classList.remove('hidden')
  }, showcaseStepDelay)
}

function showcaseInitializeAnimation() {
  showcaseMask.addEventListener('click', showcaseFadeout)
  window.setTimeout(function(){
    window.scrollTo(0, 0);
    documentBody.classList.add('u-noscroll')
    showcaseStartAnimation()
  }, showcaseAnimationDelay)
}

function showcaseFadeout() {
  showcaseMask.removeEventListener('click', showcaseFadeout)
  clearInterval(showcaseAnimation)

  window.setTimeout(function(){
    showcaseMask.classList.add('showcase__mask--lifted')
    window.setTimeout(function(){
      showcase.classList.add('showcase--transition')
      showcase.classList.remove('showcase--fullscreen')
      showcaseText.classList.remove('invisible')
      documentBody.classList.remove('u-noscroll')
      sessionStorage.setItem('stihl_gb_2020_intro_status', 'watched')
    }, showcaseFinalTransitionDelay)
  }, showcaseStepDelay)
}
